import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Lock, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ProLockOverlay = ({ feature, children }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const featureInfo = {
    supplements: {
      title: t('pro.unlock_supplements', 'Unlock Supplements'),
      description: t('pro.supplements_desc', 'Track your supplement intake, create stacks, and follow coach-assigned plans.'),
    },
    diet: {
      title: t('pro.unlock_diet', 'Unlock Diet & Nutrition'),
      description: t('pro.diet_desc', 'Log meals, track macros, search millions of foods, scan barcodes, and get diet plans.'),
    },
  };

  const info = featureInfo[feature] || { title: 'Pro Feature', description: '' };

  return (
    <div className="relative min-h-[60vh]">
      <div className="blur-sm pointer-events-none select-none opacity-60">
        {children}
      </div>
      <div className="absolute inset-0 flex items-center justify-center bg-background/50 backdrop-blur-[2px]">
        <div className="bg-card border rounded-2xl p-8 max-w-sm mx-4 text-center shadow-xl">
          <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-primary" />
          </div>
          <h2 className="text-xl font-bold mb-2">{info.title}</h2>
          <p className="text-muted-foreground mb-6 text-sm">{info.description}</p>
          <Button
            onClick={() => navigate('/subscription')}
            className="w-full bg-primary hover:bg-[#e65500] text-white"
          >
            <Sparkles className="w-4 h-4 mr-2" />
            {t('pro.upgrade_to_pro', 'Upgrade to Pro')}
          </Button>
          <p className="text-xs text-muted-foreground mt-3">
            {t('pro.starting_from', 'Starting from 4.99\u20ac/month')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProLockOverlay;
